import Analytics from '@wetransfer/transfer/modules/analytics';
import Store from '@wetransfer/transfer/store';
import Actions from '@wetransfer/transfer/store/action';

export const shouldAskBeforeLeaving = (route, transfer) =>
  route.unSavedForm ||
  (route.isMobileTransfer &&
    Boolean((transfer.files || transfer.items).length));

export function createOnRouteHandler() {
  return function handleOnRoute(route) {
    // Record referral key for acqusition channel tracking
    Analytics.setReferralKey(location.search);

    // Update the Route in our store.
    Store.dispatch(Actions.Route.setRoute(route));
  };
}
